import {
  getEnglishName,
  getImages,
  getKazakhName,
  getRussianName,
  isVisibleToCustomers,
} from '@esentai/core/features/productCategory/selectors';
import withAsyncRunner from '@esentai/core/hocs/withAsyncRunner';
import { compose, T } from 'ramda';
import { connect } from 'react-redux';

import { updateCategory } from '@/features/productsCategoryPage/actions';

import EditButton from './component';

const mapStateToProps = (state, { itemId }) => ({
  itemId,
  russianName: getRussianName(state, itemId),
  englishName: getEnglishName(state, itemId),
  kazakhName: getKazakhName(state, itemId),
  images: getImages(state, itemId),
  isVisible: isVisibleToCustomers(state, itemId),
});

const mapDispatchToProps = dispatch => ({
  onClick: values => dispatch(updateCategory(values)),
  permission: T,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAsyncRunner({ runnerMethod: 'onClick' }),
)(EditButton);
